export interface IPlanEstudio {
  periodoLectivo?: string;
  duracionOficial?: number;
  totalPeriodosLectivos?: number;
}

export class PlanEstudio implements IPlanEstudio {
  constructor(public periodoLectivo?: string, public duracionOficial?: number, public totalPeriodosLectivos?: number) {}
}
